import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { useState } from "react";
import { fetchSingleProductWithIdentifier } from "../api/products.api";
import { fetchSingleModelWithIdentifier } from "../api/akeneoModels.api";

interface useModelWithIdentifierProps {
  identifier?: string;
  companyId?: number;
}

const useModelWithIdentifier = ({
  identifier,
  companyId,
}: useModelWithIdentifierProps) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken])
  );

  const {
    data: modelData,
    error: modelError,
    isLoading: isLoadingModel,
    isSuccess: isSuccessModel,
  } = useQuery({
    queryKey: ["models", identifier],
    queryFn: () =>
      fetchSingleModelWithIdentifier(
        bearerToken as string,
        companyId as number,
        identifier as string
      ),
    enabled: !!identifier && !!companyId,
  });

  return {
    modelData,
    modelError,
    isLoadingModel,
  };
};

export default useModelWithIdentifier;
